(function () {
    function replaceVideo(event) {
        let previewLink = event.target;
        let container = previewLink.closest('.video-shariff-container');

        while (!previewLink.classList.contains('video-shariff-play')) {
            previewLink = previewLink.parentElement;
        }
        container.outerHTML = JSON.parse(previewLink.dataset.video);
    }

    let videos = document.getElementsByClassName('video-shariff-play'), i = 0;
    for (i; i < videos.length; i++) {
        videos[i].onclick = function(event){event.preventDefault(); replaceVideo(event);};
    }
})();
